// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));




export default function SignBasic(props) {
	const classes = useStyles();
	const {user, sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	//const [loaded, setLoaded] = React.useState(false);
	//const [types, setTypes] = React.useState([]);
	//const [changed, setChanged] = React.useState(false);
	//const [saveLabel, setSaveLabel] = React.useState('Save');
	const datavars = ['pixel_test_enable', 'samplesPerFile', 'radarDataRecorder', 
					   //'samplePeriod', 'analogSamplesPerFile', 
					   'max_spl_speed', 'analogDataRecorder', 'process_stats'];
	const [datas, setDatas] = React.useState({
		pixel_test_enable: 1,
		samplesPerFile: 2500,
		radarDataRecorder: 1, //Name
		max_spl_speed: 99,
		process_stats : 1,
	});
	const limits = {
		samplesPerFile: 4294967295,
		max_spl_speed: 255
	};
	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			var bds = {};
			datavars.forEach((bd) => bds[bd] = sign[bd]);
			if(!bds.max_spl_speed)
				bds.max_spl_speed = 0;
			setDatas(bds);
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		let newDetails = Object.assign({}, datas);
		
		//if numeric
		
		if([
			'samplesPerFile', 
			'max_spl_speed'
		   ].indexOf(name) !== -1){
			value = parseInt(value);
			//clean the value
			if(isNaN(value) || value < 0){
				value = 0;
			} else if(value > limits[name]){
				value = limits[name];
			}
		} else {
			value = e.target.checked ? 1 : 0;
		}
		
		newDetails[name] = value;
		setDatas(newDetails);
		if(onChange){
			console.log('Somethings Changed');
			onChange(newDetails);
		}
		//setChanged(true);
	}
	const renderSPF = () => {
		if(datas.radarDataRecorder)
			return (
				<TextField
					id="sign_spf"
					name="samplesPerFile"
					label="Speed samples per file"
					type="number"
					value={datas.samplesPerFile.toString()}
					onChange={handleChangeValue}
					inputProps={{min:'0', max:limits.samplesPerFile, style:{textAlign:'right'}}}
					fullWidth
				/>
			);
		return '';
	}
	const renderMSDS = () => {
		if(user.edit_function)
			return (
				<TextField
							id="sign_max_spl_display_speed"
							name="max_spl_speed"
							label="Maximum stats display speed"
							type="number"
							value={datas.max_spl_speed.toString()}
							onChange={handleChangeValue}
							inputProps={{min:'0', max:limits.max_spl_speed, style:{textAlign:'right'}}}
							fullWidth
						/>
			);
		return '';
			
	}
	const renderPS = () => {
		if(datas.radarDataRecorder) return (
			<FormControlLabel
          		control={<Switch checked={Boolean(datas.process_stats)} onChange={handleChangeValue} name="process_stats" />}
          		label={datas.process_stats ? "Process speed data": "No data processing"}
        	/>
		);
		return '';
	}
	
	
	return (
		<Card className={classes.root}>
			<CardHeader title="Data" />
	  		<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<FormControlLabel
          					control={<Switch checked={Boolean(datas.radarDataRecorder)} onChange={handleChangeValue} name="radarDataRecorder" />}
          					label={datas.radarDataRecorder ? "Collect speed data": "No data collection"}
        				/>
						{renderPS()}
						<FormControlLabel
          					control={<Switch checked={Boolean(datas.analogDataRecorder)} onChange={handleChangeValue} name="analogDataRecorder" />}
          					label={datas.analogDataRecorder ? "Log power data": "No power logging"}
        				/>
						<FormControlLabel
          					control={<Switch checked={Boolean(datas.pixel_test_enable)} onChange={handleChangeValue} name="pixel_test_enable" />}
          					label={datas.pixel_test_enable ? "Check dead pixels": "No pixel monitoring"}
        				/>
						
					</Grid>
					<Grid item xs={12} sm={6}>
						{renderSPF()}
						{renderMSDS()}
					</Grid>
				</Grid>
	  		</CardContent>
	  	</Card>
	);
}
